import { render } from "./PeopleMediumDevice.vue?vue&type=template&id=0a229ecb&scoped=true"
import script from "./PeopleMediumDevice.vue?vue&type=script&lang=js"
export * from "./PeopleMediumDevice.vue?vue&type=script&lang=js"

import "./PeopleMediumDevice.vue?vue&type=style&index=0&id=0a229ecb&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a229ecb"]])

export default __exports__